import classNames from 'classnames';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  primary?: boolean;
};

const BackArrow = styled.svg`
  width: 9px;
  height: 14px;
  stroke: var(--cvna-color-grey-3);

  &.primary {
    stroke: var(--cvna-color-blue-2);
  }
  &.reversed {
    transform: rotate(180deg);
  }
`;

const BackArrowIcon = forwardRef<SVGSVGElement, OwnProps>(
  ({ className = '', primary, ...props }, ref) => (
    <BackArrow
      viewBox="0 0 9 14"
      fill="none"
      ref={ref}
      className={classNames(className, { primary })}
      {...props}
    >
      <path
        d="M7.7999 1.64844L1.3999 7.29872L7.7999 12.949"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BackArrow>
  )
);

export default BackArrowIcon;
